<template>
  <section class="landing-page">
    <Header />
    <MainInfo currentCard="Extract Colors DevTool" />
    <Pricing />
    <ProductHunt />
    <Footer />

    <section class="hunt"></section>

    <footer class="footer"></footer>
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import MainInfo from "@/components/comparison/MainInfo";
import Pricing from "@/components/landing/Pricing";
import ProductHunt from "@/components/landing/ProductHunt";
import Footer from "@/components/landing/Footer";
import { updateMetaTag, updateCanonical } from '@/utils/useHeadUtils';

export default {
  components: {
    Header,
    MainInfo,
    Pricing,
    ProductHunt,
    Footer,
  },
  mounted() {
    const title = 'Site Palette vs. Extract Colors DevTool: Why Site Palette Leads with Advanced Features';
    const description = 'Discover how Site Palette outperforms Extract Colors DevTool with its superior palette exporting, profile management, and seamless integration with design tools, offering a more efficient workflow for designers.';

    document.title = title;
    updateMetaTag('description', description);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateCanonical('https://palette.site/vs-extract');
  },
};
</script>
<style scoped>

* {
  color: #3d3d3d;
}

.landing-page {
  width: 100%;
  box-sizing: border-box;
}

</style>
